/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PacoteQuartos } from '../models/PacoteQuartos';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class QuartosService {

    /**
     * ListModelMixin and GenericViewSet only Viewset
     * @returns PacoteQuartos
     * @throws ApiError
     */
    public static quartosList({
        campanha,
    }: {
        /**
         * Identifica univocamente uma campanha
         */
        campanha?: string,
    }): CancelablePromise<Array<PacoteQuartos>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/gestao/quartos',
            query: {
                'campanha': campanha,
            },
        });
    }

}
